import React from 'react';
import { Column } from 'react-table';
import { Link } from 'react-router-dom';
import { RoleService } from 'Services';
import EllipsisTooltip from 'Components/EllipsisTooltip';
import styles from 'Routes/ManageTenants/ManageTenants.css';

type TenantGroupsColumnsProps = {
    handleDelete?: (props: TenantGroup) => void;
};

const useGetTenantGroupColumns = ({ handleDelete }: TenantGroupsColumnsProps) => {
    const hasTenantWriteAccess = RoleService.hasTenantGroupWriteAccess;
    const columns: Column<TenantGroup>[] = [
        {
            id: 'name',
            accessor: 'name',
            Header: 'Name',
            dataType: 'text',
            renderType: 'overrideCell',
            Cell: ({ cell, value }) => {
                return handleDelete ? (
                    <Link className={styles.revisionTenantNameBtn} to={`/tenants/tenant-group/${cell.row.original.id}`}>
                        <EllipsisTooltip text={String(value)} />
                    </Link>
                ) : (
                    <EllipsisTooltip text={String(value)} className={styles.revisionTenantNameBtn} />
                );
            }
        },
        {
            accessor: 'description',
            Header: 'Description',
            dataType: 'text'
        },
        {
            accessor: 'numberOfTenants',
            Header: 'Tenants',
            dataType: 'number'
        },
        {
            accessor: 'modifiedAt',
            Header: 'Last Modified',
            renderType: 'datetime',
            dataType: 'datetime'
        }
    ];

    if (hasTenantWriteAccess && handleDelete !== undefined) {
        columns.push({
            accessor: 'id',
            id: 'trash',
            disableSortBy: true,
            width: 10,
            minWidth: 10,
            renderType: 'trashIcon',
            renderOptions: (props) => {
                return {
                    onClick: (id) => handleDelete?.({ ...props, id })
                };
            }
        });
    }

    return columns;
};

export default useGetTenantGroupColumns;
